import { loaderById, loaderDashboard, loaderGrid } from "../../middleware/route-provider.js";

import BasicInformationGridPage from "./grid/index.js";
import BasicInformationPage from "./index.js";

import CompanyInformationModifyPage from "./grid/company-information/CompanyInformationModify.js";
import CompanyInformationPage from "./grid/company-information/index.js";

import CityInformationModifyPage from "./grid/city-information/CityInformationModify.js";
import CityInformationPage from "./grid/city-information/index.js";

import CounterInformationModifyPage from "./grid/counter-information/CounterInformationModify.js";
import CounterInformationPage from "./grid/counter-information/index.js";

import FeederModifyPage from "./grid/feeder/FeederModify.js";
import FeederPage from "./grid/feeder/index.js";

import SubstationPage from "./grid/substation/index.js";
import SubstationModifyPage from "./grid/substation/SubstationModify.js";

import BasicInformationAdministrationPage from "./administration/index.js";
import BasicSoftwareSettingsPage from "./administration/basic-software-settings/index.js";
import BasicSoftwareSettingsModifyPage from "./administration/basic-software-settings/BasicSoftwareSettingsModify.js";
import SolarentOfficialBankAccountPage from "./administration/solarent-official-bank-accounts/index.js";
import SolarentOfficialBankAccountModifyPage from "./administration/solarent-official-bank-accounts/SolarentOfficialBankAccountModify.js";
import InitializePage from "./administration/initialize/index.js";
import AlarmsPage from "./administration/alarms/index.js";
import AlarmsModifyPage from "./administration/alarms/AlarmsModify.js";

import DefaultApiService from "../../../infrastructure/api/default.js";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  path: "BI",
  children: [
    {
      path: "",
      element: <BasicInformationPage />,
    },
    {
      path: "Grid",
      element: <BasicInformationGridPage />,
      loader: async () =>
        await loaderDashboard({
          url: "BI/Grid",
        }),
    },

    // Company Information
    {
      path: "Grid/CompanyInformation",
      element: <CompanyInformationPage />,
      loader: async () => {
        return await loaderGrid({
          url: "BI/Grid/CompanyInformation",
        });
      },
    },
    {
      path: "Grid/CompanyInformation/:id",
      element: <CompanyInformationModifyPage />,
      loader: async ({ params }) => {
        return await loaderById({
          params,
          initValue: {
            companyInformation: {
              companyName: "",
              state: "",
              address: "",
              isOwner: false,
              isActive: false,
            },
          },
          url: "BI/Grid/CompanyInformation",
        });
      },
    },

    // City Information
    {
      path: "Grid/CityInformation",
      element: <CityInformationPage />,
      loader: async () => {
        return await loaderGrid({
          url: "BI/Grid/CityInformation",
        });
      },
    },
    {
      path: "Grid/CityInformation/:id",
      element: <CityInformationModifyPage />,
      loader: async ({ params }) => {
        return await loaderById({
          params,
          initValue: {
            city: {
              cityName: "",
              companyId: "1",
              provinceId: "", 
              cityCode: "",
              isActive: true,
            },
          },
          url: "BI/Grid/CityInformation",
        });
      },
    },

    // Counter Information
    {
      path: "Grid/CounterInformation",
      element: <CounterInformationPage />,
      loader: async () => {
        try {
          const res = await DefaultApiService.getListApi(
            "BI/Grid/CounterInformation"
          );
          if (res.status === 404) {
            throw new Response("Not Found", { status: 404 });
          }

          return res.data || [];
        } catch (error) {
          return null;
        }
      },
    },
    {
      path: "Grid/CounterInformation/:id",
      element: <CounterInformationModifyPage />,
      loader: async ({ params }) => {
        let id = params?.id,
          result = {};

        if (id && id === "create") {
          id = 0;
          result = {
            counter: {
              serial: "",
              counterModel: "",
              counterDataSource: "",
              isActive: true,
            },
          };
        }

        const res = await DefaultApiService.getOneApi(
          "BI/Grid/CounterInformation",
          id
        );

        if (res.status === 404) {
          throw new Response("Not Found", { status: 404 });
        }

        const sendData = { ...res.data, ...result };
        console.log("CounterInformation", sendData);

        return sendData;
      },
    },

    // Feeder Information
    {
      path: "Grid/FeederInformation",
      element: <FeederPage />,
      loader: async () => {
        try {
          const res = await DefaultApiService.getListApi(
            "BI/Grid/FeederInformation"
          );
          if (res.status === 404) {
            throw new Response("Not Found", { status: 404 });
          }

          return res.data || [];
        } catch (error) {
          return null;
        }
      },
    },
    {
      path: "Grid/FeederInformation/:id",
      element: <FeederModifyPage />,
      loader: async ({ params }) => {
        let id = params?.id,
          result = {};

        if (id && id === "create") {
          id = 0;
          result = {
            feeder: {
              feederName: "",
              substationId: "",
              transformationId: "",
              feederIGMCCode: "",
              feederGeoCode: "",
              ownerCompanyId: "",
              ownerCityId: "",
              maxRange: "",
              minRange: "",
              percentAgriculture: "",
              percentHouseholds: "",
              percentIndustrial: "",
              percentPublic: "",
              percentOther: "",
              ownershipKind: "",
              feederKind: "",
              feederActDate: new Date(),
              feederDismandDate: null,
            },
          };
        }

        const res = await DefaultApiService.getOneApi(
          "BI/Grid/FeederInformation",
          id
        );

        if (res.status === 404) {
          throw new Response("Not Found", { status: 404 });
        }

        const sendData = { ...res.data, ...result };
        console.log("FeederInformation", sendData);

        return sendData;
      },
    },

    // Substation Information
    {
      path: "Grid/SubstationInformation",
      element: <SubstationPage />,
      loader: async () => {
        try {
          const res = await DefaultApiService.getListApi(
            "BI/Grid/SubstationInformation"
          );
          if (res.status === 404) {
            throw new Response("Not Found", { status: 404 });
          }

          return res.data || [];
        } catch (error) {
          return null;
        }
      },
    },
    {
      path: "Grid/SubstationInformation/:id",
      element: <SubstationModifyPage />,
      loader: async ({ params }) => {
        let id = params?.id,
          result = {};

        if (id && id === "create") {
          id = 0;
          result = {
            substation: {
              substationName: "",
              substationLatinName: "",
              substationDispatchingCode: "",
              substationIGMCCode: "",
              substationGeoCode: "",
              substationGISCode: "",
              substationTotalCapacity: "",
              percentInOutDiff: "",
              substationKind: "",
              companyId: "",
              cityId: "",
              substationActDate: new Date(),
              substationDismandDate: null,
            },
          };
        }

        const res = await DefaultApiService.getOneApi(
          "BI/Grid/SubstationInformation",
          id
        );

        if (res.status === 404) {
          throw new Response("Not Found", { status: 404 });
        }

        const sendData = { ...res.data, ...result };
        console.log("SubstationInformation", sendData);

        return sendData;
      },
    },

    // Administration
    {
      path: "Administration",
      element: <BasicInformationAdministrationPage />,
    },
    {
      path: "Administration/Initialize",
      element: <InitializePage />,
    },
    {
      path: "Administration/BasicSoftwareSettings",
      element: <BasicSoftwareSettingsPage />,
      loader: async () =>
        await loaderGrid({
          url: "BI/Administration/BasicSoftwareSettings",
        }),
    },
    {
      path: "Administration/BasicSoftwareSettings/:id",
      element: <BasicSoftwareSettingsModifyPage />,
      loader: async ({ params }) => {
        return await loaderById({
          params,
          url: "BI/Administration/BasicSoftwareSettings",
          initValue: {
            basicSoftwareSettings: {
              agentServerUrl: "",
              appUrl: "",
              igmcUsername: "",
              igmcPassword: "",
              smsServerUrl: "",
              esbServerUrl: "",
              isDirectInternet: false,
              isActiveLogger: false,
              mapCenterLat: 32.68,
              mapCenterLong: 51.68,
              mapZoom: 9,
              googleMapUrl: "",
              googleEarthUrl: "",
              neshanApiKey: "",
              hasNeshanApiKey: false,
              neshanServiceApiKey: "",
              hasNeshanServiceApiKey: false,
              mapServiceKind: "Default",
            },
          },
        });
      },
    },
    {
      path: "Administration/SolarentOfficialBankAccount",
      element: <SolarentOfficialBankAccountPage />,
      loader: async () =>
        await loaderGrid({
          url: "BI/Administration/SolarentOfficialBankAccount",
        }),
    },
    {
      path: "Administration/SolarentOfficialBankAccount/:id",
      element: <SolarentOfficialBankAccountModifyPage />,
      loader: async ({ params }) =>
        await loaderById({
          params,
          url: "BI/Administration/SolarentOfficialBankAccount",
          initValue: {
            title: "",
            bankAccountHolderName: "",
            bankName: "",
            bankAccountNumber: "",
            bankShebaNumber: "",
            bankCardNumber: "",
            isActive: false,
          },
        }),
    },
    {
      path: "Administration/Alarms",
      element: <AlarmsPage />,
      loader: async () =>
        await loaderGrid({
          url: "BI/Administration/Alarms",
        }),
    },
    {
      path: "Administration/Alarms/:id",
      element: <AlarmsModifyPage />,
      loader: async ({ params }) => {
        return await loaderById({
          params,
          url: "BI/Administration/Alarms",
          initValue: {
            alarms: {
              title: "",
              alarmDetails: "",
              importance: "",
              alarmStatus: "",
            },
          },
        });
      },
    },
  ],
};
